import './Home.css';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import note from '../assets/Note.svg';
import filledBlueSpeech from '../assets/filledBlueSpeech.svg';
import hollowSpeech from '../assets/hollowSpeech.svg';
import share from '../assets/Share.svg';
import hollowFavourite from '../assets/hollowFavourite.svg';
import speech from '../assets/Speech.svg';
import learning from '../assets/yourLearning.svg';
import favourite from '../assets/Favourite.svg';

import AudioVisualizer from '../components/AudioVisualizer';
import CircularProgress from '@mui/joy/CircularProgress';
import Typography from '@mui/joy/Typography';
import { useCountUp } from 'use-count-up'
import SpeakText from '../components/SpeakText';


export default function Home() {

    // const [currentIndex, setCurrentIndex] = useState(0);
    const [showVisualizer, setShowVisualizer] = useState(false);
    const [showWordBreakVisualizer, setShowWordBreakVisualizer] = useState(false);
    const [bookmark, setBookMark] = useState(false);
    const [wordOfTheDay, setWordOfTheDay] = useState({});
    const [completedWords, setCompletedWords] = useState({});
    const studyPercentileRef = useRef(75);
    let date = new Date().toString().replace(/\w+ (\w+) (\d+) (\d+).*/, '$2 $1 $3');
    const { value: value2 } = useCountUp({
        isCounting: true,
        duration: 1.1,
        start: 0,
        end: studyPercentileRef.current,
    });

    const userId = sessionStorage.getItem('userId');



    const handleHollowSpeechClick = () => {
        if (showVisualizer) {
            setShowVisualizer(true);
        } else {
            setShowVisualizer(true);
        }
    };

    const handleVoiceBreakSpeech = () => {
        if (showWordBreakVisualizer) {
            setShowWordBreakVisualizer(false);
        } else {
            setShowWordBreakVisualizer(true);
        }
    }

    const onSpeechEnd = () => {
        setShowVisualizer(false);
        setShowWordBreakVisualizer(false);
    }



    useEffect(() => {
        fetch('https://alembicdigilabs.in/medicaldictionary/v1/eyecare/random-keyword', {
            method: 'GET',
            headers: {
                'authorization': `bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Assuming the API returns a word object with name and syllables properties
                setWordOfTheDay(data.data);
            })
    }, []);

    useEffect(() => {
        // fetch(`http://10.40.8.36:4004/medicaldictionary/v1/eyecare/progress/${userId}`, {
        fetch(`https://alembicdigilabs.in/medicaldictionary/v1/eyecare/progress/${userId}`, {
            method: 'GET',
            headers: {
                'authorization': `bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Assuming the API returns a word object with name and syllables properties
                // setWordOfTheDay(data.data);
                setCompletedWords(data);
                studyPercentileRef.current = Math.ceil(parseFloat(data.completionPercentage));

            })
    }, []);



    const addToBookmark = async () => {

        let data = {
            UserId: userId,
            Type: wordOfTheDay.Brand ? 'Brand' : 'Molecule',
            Name: wordOfTheDay.Brand || wordOfTheDay?.Name,
            Brand_Name: wordOfTheDay?.Brand_Name,
            Vocab_Breakdown: wordOfTheDay?.Vocab_Breakdown,
            Definition: wordOfTheDay?.Definition,
            Mode_of_Action: wordOfTheDay?.Mode_of_Action,
            Common_Usage: wordOfTheDay?.Common_Usage,
            action: bookmark ? 'delete' : 'add'
        }
        const apiUrl = 'https://alembicdigilabs.in/medicaldictionary/v1/eyecare/favourites';

        try {
            const response = await fetch(apiUrl, {
                method: 'POST', // HTTP method
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                const result = await response.json();
                setBookMark(prev => !prev);
                console.log('Response:', result); // Log the response from the API
            } else {
                console.error('Error:', response.statusText); // Log any errors
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }


    return (
        <div className="dictionary-container">
            {/* Header */}
            <header className="text-left py-3">
                <p className='dictionaryHeader'>Learning Center</p>
            </header>

            <div className='favourite-header justify-content-between'>
                <div className='d-flex gap-2'>
                    <img src={note} alt="Card 2" />
                    <p>Word of the day!</p>
                </div>
                <span className='date'>{date}</span>
            </div>

            {/* Word Details Section */}
            <div className="word-details-container shadow-lg border rounded-4 p-4 my-4">
                <div className='d-grid gap-4' style={{ gridTemplateColumns: '1fr 1fr', width: '100%' }}>
                    <p className='mb-0 fs-2'>{wordOfTheDay.Brand || wordOfTheDay.Molecule_Name}</p>
                    <div className='d-grid' style={{ gridTemplateColumns: 'repeat(3, 1fr)', width: '100px', justifySelf: 'end' }}>
                        <img src={!showVisualizer ? hollowSpeech : filledBlueSpeech} alt='speech' className='col-md-4 w-75' onClick={handleHollowSpeechClick} />
                        <img src={share} alt='share' className='col-md-4 w-75' />
                        <img src={bookmark ? favourite : hollowFavourite} alt='bookmark' className='col-md-4 w-75' onClick={addToBookmark} />
                    </div>
                </div>
                {showVisualizer && (
                    <AudioVisualizer />
                )}

                {showVisualizer && <SpeakText textToSpeak={wordOfTheDay.Molecule_Name} speechRate={'0.7'} onSpeechEnd={onSpeechEnd} />}

                <div className='vocab-breakdown mt-4 px-3' style={showWordBreakVisualizer ? { height: '160px' } : { height: '110px' }}>
                    <div className='d-flex justify-content-between align-items-center' style={{ borderBottom: '2px solid rgba(218, 223, 230, 1)' }}>
                        <span className='fs-12'>Vocab Breakdown:</span>
                        <img src={showWordBreakVisualizer ? filledBlueSpeech : speech} alt='speaker' style={{ height: '1.2rem' }} onClick={handleVoiceBreakSpeech} />
                    </div>
                    <span style={{ placeContent: 'center', placeSelf: 'center', fontStyle: 'italic', fontSize: '16px' }}>{wordOfTheDay.Vocab_Breakdown}</span>

                    {showWordBreakVisualizer && (<div style={{ borderTop: '2px solid rgba(218, 223, 230, 1)' }}>
                        <AudioVisualizer /></div>
                    )}
                    {showWordBreakVisualizer && <SpeakText textToSpeak={wordOfTheDay.Molecule_Name} speechRate={'0.2'} onSpeechEnd={onSpeechEnd} />}
                </div>

                <div className="info-section">
                    <InfoItem label="Definition" content={wordOfTheDay.Definition} />
                    <InfoItem label="Mode of Action" content={wordOfTheDay.Mode_of_Action} />
                    <InfoItem label="Common Usage" content={wordOfTheDay.Common_Usage} />
                    <div className="info-associated-brands">
                        <span className="info-label">Associated Brand(s):</span>
                        <p className="info-description mb-0 mt-2">{wordOfTheDay.Brand_Name || wordOfTheDay.Associated_Brands}</p>
                    </div>
                </div>
            </div>


            {/* Your Learning Section */}

            <div className='favourite-header gap-2 mt-4'>
                <img src={learning} alt="learning" />
                <p className='mb-0'>Your Learning</p>
            </div>
            <div className='learning-percentile-container' >
                <div className='p-3'>
                    <div className='d-grid gap-3' style={{ gridTemplateColumns: '1fr 3fr' }}>
                        <CircularProgress size="lg" determinate value={value2} style={{ placeSelf: 'center' }}>
                            <Typography>{value2}%</Typography>
                        </CircularProgress>
                        <div>
                            <span className='fs-8' style={{ fontSize: '12px' }}>chapter 1</span>
                            <h4 className='mb-1 mt-1 fs-6'>Discovering Eyecare</h4>
                            <span style={{ fontSize: '16px' }}>Continue your journey</span>
                        </div>
                    </div>
                    <Link to={'/yourLearning'} state={{ completedBrands: completedWords.completedBrands, completedMolecules: completedWords.completedMolecules }} className='text-decoration-none'>
                        <div className='d-flex justify-content-center align-items-center text-white rounded-5 
                            mt-4 sucessContinue'>Continue Studying</div>
                    </Link>
                </div>
            </div>
        </div>
    );
}

const InfoItem = ({ label, content }) => (
    <div className="info-item">
        <span className="info-label">{label}:</span>
        <p className="info-description mb-0">{content}</p>
    </div>
);

